var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoTutorialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3966_9338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#626262"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3966_9338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12516 13.3654L13.3656 10L8.12516 6.63458V13.3654ZM3.58995 16.25C3.16898 16.25 2.81266 16.1042 2.521 15.8125C2.22933 15.5208 2.0835 15.1645 2.0835 14.7435V5.25646C2.0835 4.83549 2.22933 4.47917 2.521 4.1875C2.81266 3.89583 3.16898 3.75 3.58995 3.75H16.4104C16.8313 3.75 17.1877 3.89583 17.4793 4.1875C17.771 4.47917 17.9168 4.83549 17.9168 5.25646V14.7435C17.9168 15.1645 17.771 15.5208 17.4793 15.8125C17.1877 16.1042 16.8313 16.25 16.4104 16.25H3.58995ZM3.58995 15H16.4104C16.4745 15 16.5333 14.9733 16.5866 14.9198C16.6401 14.8665 16.6668 14.8077 16.6668 14.7435V5.25646C16.6668 5.19229 16.6401 5.13354 16.5866 5.08021C16.5333 5.02674 16.4745 5 16.4104 5H3.58995C3.52579 5 3.46704 5.02674 3.4137 5.08021C3.36023 5.13354 3.3335 5.19229 3.3335 5.25646V14.7435C3.3335 14.8077 3.36023 14.8665 3.4137 14.9198C3.46704 14.9733 3.52579 15 3.58995 15Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTutorialsIcon);
export default __webpack_public_path__ + "static/media/video-tutorials-icon.ccbf24b85f90366439fc4f3579b4687b.svg";
export { ForwardRef as ReactComponent };